import { useState } from "react";

import { ModelSchemaAddToCatalogue } from "./components/model-schema-add-to-catalogue";
import { ModelSchemaSubmitOptions } from "./components/model-schema-submit-options";
import { ModelSchemaUpdateInCatalogue } from "./components/model-schema-update-in-catalogue";

interface ProjectFileModelSchemaToCataloguerops {
  fileId: string;
  onClose: () => void;
}

export type SubmitType = "add" | "update" | null;

export const ProjectFileModelSchemaToCatalogue = ({
  fileId,
  onClose: onCloseAllExternal,
}: ProjectFileModelSchemaToCataloguerops) => {
  const [submitType, setSubmitType] = useState<SubmitType>(null);

  const [optionsModalOpen, setOptionsModalOpen] = useState(true);

  // Seperate onClose and onCloseAll functions to handle closing of modals
  // onClose reset the submitType to null closing the add or update modal
  // onCloseAll closes all modals and calls the external onClose function after a delay to ensure the exit animation of the modal is completed before the parent component is notified and the entire component is unmounted. This prevents the modal from being unmounted before the exit animation is completed, which would cause the animation to be cut off and not play properly.
  const onClose = () => {
    setSubmitType(null);
  };

  const onCloseAll = () => {
    setOptionsModalOpen(false);
    onClose();
    setTimeout(() => {
      onCloseAllExternal();
    }, 500);
  };

  return (
    <>
      <ModelSchemaAddToCatalogue
        fileId={fileId}
        isOpen={submitType === "add"}
        onClose={onClose}
        onCloseAll={onCloseAll}
      />
      <ModelSchemaUpdateInCatalogue
        fileId={fileId}
        isOpen={submitType === "update"}
        onClose={onClose}
        onCloseAll={onCloseAll}
      />

      <ModelSchemaSubmitOptions
        isOpen={optionsModalOpen}
        onCloseAll={onCloseAll}
        setSubmitType={setSubmitType}
      />
    </>
  );
};
